import { BaseFetch } from "../main-model";
export default class ExportPP9Model extends BaseFetch {
  getExportPP9By = (data) =>
    this.authFetch({
      url: "export-pp9/getExportPP9By",
      method: "POST",
      body: JSON.stringify(data),
    });
}
